// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CK86x","textarea":"styles_textarea__cZMVC"};